module.exports = __webpack_public_path__ + "static/media/login_fail.6867521e.png";